
<template>
  <div id="app">
    <section class="hero is-large is-primary is-bold">
      <div calss="hero-body">
        <div class="container">
          <h1 class="title">Zebediah Montoya</h1>
          <p>Hello, this is my personal website!</p>
        </div>
      </div>
    </section>
    <section id="navbar" class="section is-primary">
        <nav class="navbar is-primary" role="navigation">
          <router-link to="/"  class="navbar-item is-link">Home</router-link>
          <router-link to="/contact" class="navbar-item is-link">About</router-link>
        </nav>
      </section>
    <section id="main-body" class="section">
      <div class="container">
        <div class="box">
          <router-view></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html{
  background-color: rgba(255,211,110,1);
  width: 100%;
  height: 100%;
}

#hero-body{
  text-align: center;
}

#navbar{
  margin-top: 0px;
  padding: 0px;
  border-bottom-width: 4px;
}

router-link.navbar-item{
  margin:auto;
  padding-bottom: 20px;
  text-align: center;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

.box{
  box-shadow: 100px 100px, 5px, grey;
}

.hero{
  padding: 40px;
}
</style>
